import { Flex, Text, Table, TableHeader, TableBody, TableRow, TableCell } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import { deleteIconCell, deleteIcon } from "./styles_vanilla.css";
import type { ChangeInspectionModalProps } from "./types";

type FamilyModeContentProps = {
  familyChange: NonNullable<
    Extract<ChangeInspectionModalProps, { mode: "family" }>["familyChange"]
  >;
  readOnly: boolean;
  onDeleteChange?: (index: number) => void;
};

export const FamilyModeContent = ({
  familyChange,
  readOnly,
  onDeleteChange,
}: FamilyModeContentProps) => {
  const maxRows = Math.max(
    familyChange.currentEntities.length,
    familyChange.proposedEntities.length,
  );
  const paddedCurrent = [
    ...familyChange.currentEntities,
    ...Array<string>(maxRows - familyChange.currentEntities.length).fill("--"),
  ];
  const paddedProposed = [
    ...familyChange.proposedEntities,
    ...Array<string>(maxRows - familyChange.proposedEntities.length).fill("--"),
  ];

  return (
    <Table variant="muted" hasBottomBorder>
      <TableHeader>
        <TableRow>
          <TableCell header />
          <TableCell header>
            <Text variant="secondary-md" color={Colors.Neutral600}>
              Current
            </Text>
          </TableCell>
          <TableCell header>
            <Text variant="secondary-md" color={Colors.Neutral600}>
              Proposed
            </Text>
          </TableCell>
          {!readOnly && <TableCell header />}
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell>
            <Text variant="regular-md">Billing group entities</Text>
          </TableCell>
          <TableCell>
            <Flex flexDirection="column" gap={SPACING.X_SMALL}>
              {paddedCurrent.map((val, index) => (
                <Text key={`current-${index}`} variant="regular-md">
                  {val}
                </Text>
              ))}
            </Flex>
          </TableCell>
          <TableCell>
            <Flex flexDirection="column" gap={SPACING.X_SMALL}>
              {paddedProposed.map((val, index) => (
                <Text key={`proposed-${index}`} variant="regular-md">
                  {val}
                </Text>
              ))}
            </Flex>
          </TableCell>
          {!readOnly && (
            <TableCell className={deleteIconCell}>
              <Icon
                type="trash"
                variant="outline"
                size="medium"
                color={Colors.Neutral500}
                className={deleteIcon}
                aria-label="Delete proposed change"
                onClick={() => onDeleteChange?.(0)}
              />
            </TableCell>
          )}
        </TableRow>
      </TableBody>
    </Table>
  );
};
